import { render } from "./AdminStreamingProvidersPage.vue?vue&type=template&id=4f2f854d&scoped=true"
import script from "./AdminStreamingProvidersPage.vue?vue&type=script&lang=js"
export * from "./AdminStreamingProvidersPage.vue?vue&type=script&lang=js"

import "./AdminStreamingProvidersPage.vue?vue&type=style&index=0&id=4f2f854d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f2f854d"]])

export default __exports__